import React, { useEffect, useState } from "react";
import "./boxedDetails.css";
import Global from "../../global";
import Share from "../share/share";
import {
  favourited,
  favourites,
  formatUTCDate,
  getTimeFromISODateString,
} from "../javascript/function";
import { UserStore } from "../store/store";
import ShowMoreText from "react-show-more-text";
import { useTranslation } from "react-i18next";

const YoutubeDetails = (props) => {
  const currentUser = UserStore.useState((s) => s.user);
  const [box, setBox] = useState(props.data);
  const { t } = useTranslation(["translation"]);
  const [hrs, setHrs] = useState("");
  const [mins, setMins] = useState("");
  const [sec, setSec] = useState("");

  useEffect(() => {
    setBox(props.data);
    const time = getTimeFromISODateString(props.data.contentDetails.duration);
    setHrs(time.hrs);
    setMins(time.mins);
    setSec(time.second);
  }, [props.data]);

  return (
    <div className="boxedDetail youtuber">
      <div className="play-details-content">
        <div className="title-block d-flex align-items-center justify-content-between">
          <h2 className="play-title">{box.snippet.title}</h2>
        </div>
        <div className="social">
          {Global.FAVOURITES ? (
            <a
              href="#!"
              className="icon-bttn"
              onClick={(event) => {
                favourites(event, box, "video");
              }}
            >
              <i
                className={
                  favourited(box.id, currentUser.FAVOURITES)
                    ? "ri-check-fill text-white"
                    : "ri-add-line text-white"
                }
              />
            </a>
          ) : (
            ""
          )}
          {Global.SOS ? (
            <a href="#!" className="icon-bttn share">
              <i className="ri-share-line text-white" />{" "}
              <Share type={"video"} details={box} {...props}></Share>
            </a>
          ) : (
            ""
          )}
          {Global.OFFLINE ? (
            <a href="#!" className="icon-bttn">
              <i className="ri-download-line text-white" />
            </a>
          ) : (
            ""
          )}
          {Global.VCMS === "YouTube" ? (
            <a href="#!" className="icon-bttn">
              {" "}
              <i className="ri-eye-line text-white" />{" "}
              <span style={{ fontSize: "14px" }}>
                {box.statistics.viewCount + " "}
              </span>
            </a>
          ) : (
            ""
          )}
          {Global.VCMS === "YouTube" ? (
            <a href="#!" className="icon-bttn">
              {" "}
              <i className="ri-thumb-up-line text-white" />{" "}
              <span style={{ fontSize: "14px" }}>
                {box.statistics.likeCount + " "}
              </span>
            </a>
          ) : (
            ""
          )}
          {Global.VCMS === "YouTube" ? (
            <a href="#!" className="icon-bttn">
              <i className="ri-calendar-line text-white" />
              <span style={{ fontSize: "14px" }}>
                {" " + formatUTCDate(box.snippet.publishedAt)}
              </span>
            </a>
          ) : (
            ""
          )}
          {Global.VCMS === "YouTube" ? (
            <a href="#!" className="icon-bttn">
              <i className="ri-time-line text-white" />
              <span style={{ fontSize: "14px" }}>
                {hrs === 0
                  ? " " +
                    mins +
                    " " +
                    t("label_min") +
                    " " +
                    sec +
                    " " +
                    t("label_seconds")
                  : " " +
                    hrs +
                    " " +
                    t("label_hours") +
                    " " +
                    mins +
                    " " +
                    t("label_min") +
                    " " +
                    sec +
                    " " +
                    t("label_seconds")}
              </span>
            </a>
          ) : (
            ""
          )}
        </div>
        {/* Title Block */}
        <ShowMoreText
          /* Default options */
          lines={5}
          more={t("label_Show_More")}
          less={t("label_Show_Less")}
          keepNewLines={true}
          anchorClass="my-anchor-css-class"
          expanded={false}
          truncatedEndingComponent={"... "}
          className="details-desc"
          children={box.snippet.description}
        ></ShowMoreText>
      </div>
    </div>
  );
};

export default YoutubeDetails;
